import { BRANDS_CATEGORY_ID } from "@faire/help-center-utils/consts/BRANDS_CATEGORY_ID";
import { RETAILERS_CATEGORY_ID } from "@faire/help-center-utils/consts/RETAILERS_CATEGORY_ID";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { loadingStateCss, pageMaxWidthCss } from "@faire/help-center/components/Mixin";
import { viewAllText } from "@faire/help-center/consts";
import { useSectionStore } from "@faire/help-center/hooks/useSectionStore";
import { trackHelpCenterViewAllPopularGuidesClick } from "@faire/web-api/events/helpCenter/click/viewAllPopularGuides";
import popularGuidesPage from "@faire/web-api/routes/support/popular-guides/categoryId";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import * as React from "react";
import styled from "styled-components";
import { NAVIGATION_FROM } from "../eventEnum";
import { PopularArticlesList } from "./PopularArticlesList";
import { TermsList } from "./TermsList";
export var PopularGuides = function PopularGuides(_ref) {
  var _brandPopularGuides$a;
  var loadTimingRef = _ref.loadTimingRef;
  var _useSectionStore = useSectionStore(),
    isLoading = _useSectionStore.isLoading,
    retailerPopularGuides = _useSectionStore.retailerPopularGuides,
    brandPopularGuides = _useSectionStore.brandPopularGuides;
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var _useViewport = useViewport(),
    isMobile = _useViewport.isMobile;
  var handleViewAllClick = function handleViewAllClick(section) {
    var _getRetailerToken, _getBrandToken;
    trackHelpCenterViewAllPopularGuidesClick(section, (_getRetailerToken = getRetailerToken()) !== null && _getRetailerToken !== void 0 ? _getRetailerToken : "", (_getBrandToken = getBrandToken()) !== null && _getBrandToken !== void 0 ? _getBrandToken : "");
  };
  return /*#__PURE__*/React.createElement(Wrapper, {
    "$isLoading": isLoading,
    ref: loadTimingRef
  }, /*#__PURE__*/React.createElement(Column, {
    flex: 1,
    align: "flex-start"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "displaySSerifRegular"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "ALiNHF",
    defaultMessage: [{
      "type": 0,
      "value": "Guides populaires pour les commerçants"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "3x"
  }), /*#__PURE__*/React.createElement(PopularArticlesList, {
    articles: retailerPopularGuides.articles,
    navigatedFrom: NAVIGATION_FROM.POPULAR_RETAILER_GUIDES
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: popularGuidesPage("".concat(RETAILERS_CATEGORY_ID)),
    onClick: function onClick() {
      return handleViewAllClick(NAVIGATION_FROM.POPULAR_RETAILER_GUIDES);
    }
  }, viewAllText(retailerPopularGuides.number_of_articles, strictLocalize))), isMobile ? /*#__PURE__*/React.createElement(Spacer, {
    height: "4x"
  }) : null, (brandPopularGuides === null || brandPopularGuides === void 0 ? void 0 : (_brandPopularGuides$a = brandPopularGuides.articles) === null || _brandPopularGuides$a === void 0 ? void 0 : _brandPopularGuides$a.length) > 0 ? ( /*#__PURE__*/React.createElement(Column, {
    flex: 1,
    align: "flex-start"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "displaySSerifRegular"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "S6/pFM",
    defaultMessage: [{
      "type": 0,
      "value": "Guides populaires pour les marques"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "3x"
  }), /*#__PURE__*/React.createElement(PopularArticlesList, {
    articles: brandPopularGuides.articles,
    navigatedFrom: NAVIGATION_FROM.POPULAR_BRAND_GUIDES
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: popularGuidesPage("".concat(BRANDS_CATEGORY_ID)),
    onClick: function onClick() {
      return handleViewAllClick(NAVIGATION_FROM.POPULAR_BRAND_GUIDES);
    }
  }, viewAllText(brandPopularGuides.number_of_articles, strictLocalize)))) : null, isMobile ? /*#__PURE__*/React.createElement(Spacer, {
    height: "4x"
  }) : null, /*#__PURE__*/React.createElement(Column, {
    flex: 1,
    align: "flex-start"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "displaySSerifRegular"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "o3l0Y8",
    defaultMessage: [{
      "type": 0,
      "value": "Politiques, confidentialité et sécurité"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "3x"
  }), /*#__PURE__*/React.createElement(TermsList, {
    navigatedFrom: NAVIGATION_FROM.POLICIES_PRIVACY_SECURITY
  })));
};
var Wrapper = styled.div.withConfig({
  displayName: "PopularGuides__Wrapper"
})(["display:flex;flex-direction:column;padding:24px 24px 32px;", "{flex-direction:row;padding:40px;}", "{padding:56px;}", " ", ""], responsiveMediaQueries.tabletAndAbove, responsiveMediaQueries.desktopAndAbove, loadingStateCss, pageMaxWidthCss);